<template>
  <div class="c_user_list_change_money_pop">
    <el-dialog title="修改店铺平台服务费" width="600px" :close-on-click-modal="false" :visible.sync="show">
        <el-form size="small" :model="form" label-width="150px">
            <el-form-item label="修改类型:">
              <span>修改店铺平台服务费</span>
            </el-form-item>
            <el-form-item label="增加/减少金额:">
               <el-input-number size="medium" v-model="form.flow_price" :precision="2" :step="1"></el-input-number>
            </el-form-item>
            <!-- <el-form-item label="修改标题:">
              <el-row>
                <el-col :span="18">
                <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 6 }" placeholder="请输入修改标题" v-model="form.title"></el-input>
                </el-col>
              </el-row>
            </el-form-item> -->
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="show = false">取 消</el-button>
          <el-button type="primary" @click="apiConfigStoreConfigServerHandel">确 定</el-button>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import { apiConfigStoreConfigServer } from '@/utils/api.js'
export default {
  data() {
    return {
      show: false,

      form: {
        id: '',
        flow_price: 0,
        title: ''
      },
    }
  },
  methods: {
    // 修改买家金额
    async apiConfigStoreConfigServerHandel() {
      // if(!this.form.title) return this.$message.error('请填写修改标题！')
      let loading = this.$loading()
      const { success, data } = await apiConfigStoreConfigServer(this.form).catch(() => loading.close())
      loading.close()
      if(!success) return
      this.$message.success(data.msg)
      this.show = false
      this.$emit('emitSaveSuccess')
      console.log(data)
    },

    // status //1 修改本金余额 2修改佣金余额
    onShow(data) {
      this.form.id = data.id
      this.form.flow_price = 0
      this.form.title = ''
      this.show = true
    },
  }
}
</script>

<style lang='scss'>
</style>